import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionLike } from 'rxjs';
import { TemplateInfo } from 'src/app/common/correspondence/email-compose/email-compose.component';
import { serviceConstants } from 'src/app/constants/service.constants';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { CommonService } from 'src/app/services/common.service';
import { FileData, FileService } from 'src/app/services/file.service';

@Component({
  selector: 'app-milestone-send-notification',
  templateUrl: './milestone-send-notification.component.html',
  styleUrl: './milestone-send-notification.component.scss'
})
export class MilestoneSendNotificationComponent implements OnInit {
  @Input() private Content: any;
  subInsertDataPost: SubscriptionLike;
  subGetData5: SubscriptionLike;
  subGetData4: SubscriptionLike;
  subGetData3: SubscriptionLike;
  subUploadMultiFiles: SubscriptionLike;
  subGetData: SubscriptionLike;

  overlayTitle: string = "Compose Email";
  ComposeMail: UntypedFormGroup;
  ApplicationID: string = '';
  msgType: string = '';
  PKRRFMsgID: string;
  uploadedFileArray: FileData[] = [];
  templateInfo: TemplateInfo = new TemplateInfo();
  originalEmailBody = "";
  emailTemplates: any[] = [];
  ModuleID: string;
  filteredMails: any[];
  mails: any[];
  fileName: string;
  SubModule: string;

  editorInit: Record<string, any> | undefined = {
    base_url: '/tinymce',
    suffix: '.min',
    statusbar: false,
    menubar: false,
    height: 'calc(100vh - 340px) !important',
    paste_data_images: true
  };

  constructor(
    private commonService: CommonService,
    private apiService: ApidataRequestService,
    private modalRef: NgbActiveModal,
    private readonly fileService: FileService,

  ) { }

  ngOnDestroy(): void {
    if (this.subInsertDataPost) this.subInsertDataPost.unsubscribe();
    if (this.subGetData5) this.subGetData5.unsubscribe();
    if (this.subGetData4) this.subGetData4.unsubscribe();
    if (this.subGetData3) this.subGetData3.unsubscribe();
    if (this.subUploadMultiFiles) this.subUploadMultiFiles.unsubscribe();
    if (this.subGetData) this.subGetData.unsubscribe();
  }

  ngOnInit(): void {
    this.ApplicationID = this.Content.content.ApplicationID;
    this.msgType = this.Content.content.MailType;
    this.ModuleID = this.Content.content.ModuleID;
    this.SubModule = this.Content.content.SubModule;
    this.ComposeMail = new UntypedFormGroup({
      MsgID: new UntypedFormControl(null),
      ApplicationID: new UntypedFormControl(this.ApplicationID),
      ModuleID: new UntypedFormControl(this.ModuleID),
      SubModule: new UntypedFormControl(this.SubModule),
      //PKRRFMsgID: new UntypedFormControl(null),
      From: new UntypedFormControl(""),
      To: new UntypedFormControl([], [Validators.required]),
      CC: new UntypedFormControl([]),
      BCC: new UntypedFormControl([]),
      Subject: new UntypedFormControl("", [Validators.required, Validators.maxLength(1000)]),
      Attachments: new UntypedFormControl([]),
      IsHighImp: new UntypedFormControl(false),
      MailBody: new UntypedFormControl(""),
      //Folder: new UntypedFormControl("I"),
      TemplateID: new UntypedFormControl(""),
      HasFileChange: new UntypedFormControl(false),
      //IsReplyMail: new UntypedFormControl(false),
      //IsFwdMail: new UntypedFormControl(false)
    });
    this.getTeamMembersMails();
    this.getEmailTemplates();
  }
  sendMail() {
    if (this.ValidateForm()) {
      if (this.msgType == "new") {
        this.ComposeMail.controls["Attachments"].setValue(this.uploadedFileArray);
      }
      this.emailStore();
    }
  }

  ValidateForm(): boolean {
    let isValid = true;
    var emailto = this.ComposeMail.get('To')?.value;
    let message = "";
    if (emailto == null || emailto.length == 0) {
      message += "Enter at least one recipient in To field <br/>";
      isValid = false;
    }

    if (this.ComposeMail.controls['Subject'].hasError("required")) {
      message += "Please enter Subject <br/>";
      isValid = false;
    }
    if (this.ComposeMail.controls['Subject'].hasError("maxLength")) {
      message += "Length of Subject should not exceed 1000<br/>";
      isValid = false;
    }

    if (emailto != null && emailto.length > 0) {
      for (var i = 0; i < emailto.length; i++) {
        if (!this.commonService.validateEmail(emailto[i].EmailAddress.trim())) {
          message += 'Email id "' + emailto[i].EmailAddress + '" is invalid. Please enter valid email id to send the email<br/>';
          isValid = false;
        }
      }
    }

    var emailcc = this.ComposeMail.controls['CC'].value;
    if (emailcc != null && emailcc.length > 0) {
      for (var i = 0; i < emailcc.length; i++) {
        if (!this.commonService.validateEmail(emailcc[i].EmailAddress.trim())) {
          message += 'Email id "' + emailcc[i].EmailAddress + '" is invalid. Please enter valid email id to send the email<br/>';
          isValid = false;
        }
      }
    }

    var emailbcc = this.ComposeMail.controls['BCC'].value;
    if (emailbcc != null && emailbcc.length > 0) {
      for (var i = 0; i < emailbcc.length; i++) {
        if (!this.commonService.validateEmail(emailbcc[i].EmailAddress.trim())) {
          message += 'Email id "' + emailbcc[i].EmailAddress + '" is invalid. Please enter valid email id to send the email<br/>';
          isValid = false;
        }
      }
    }

    if (!isValid) {
      this.commonService.ValidationBanner(message);
    }
    return isValid;
  }

  emailStore = () => {
    let FOrmData = this.ComposeMail.value;
    FOrmData["Subject"] = this.ComposeMail.controls["Subject"].value;
    FOrmData["To"] = this.ComposeMail.controls["To"].value != null ? ((this.ComposeMail.controls["To"].value).map(x => { return x.EmailAddress })).toString() : "";
    FOrmData["CC"] = this.ComposeMail.controls["CC"].value != null ? ((this.ComposeMail.controls["CC"].value).map(x => { return x.EmailAddress })).toString() : "";
    FOrmData["BCC"] = this.ComposeMail.controls["BCC"].value != null ? ((this.ComposeMail.controls["BCC"].value).map(x => { return x.EmailAddress })).toString() : "";
    this.subInsertDataPost = this.apiService.InsertDataPost("api/ISTMilestones/MilestoneSendNotification/", FOrmData).subscribe(result => {
      if (result.Status) {
        this.commonService.SuccessBanner(result.SuccessMessage);
        this.modalRef.close();
      }
      else {
        var err: any = [];
        err.push(result.errMessage);
        this.commonService.ValidationBanner(err);
      }
    });
  }

  discard() {
    this.modalRef.close();
  }

  getTemplateInfo() {
    if (this.ComposeMail.controls["TemplateID"].value != "") {
      this.subGetData4 = this.apiService.getData("api/Correspondence/GetTemplateInfo?TemplateID=" + this.ComposeMail.controls["TemplateID"].value + "&ApplicationID=" + this.ApplicationID).subscribe(result => {
        if (result.Status) {
          this.templateInfo = result.Data;
          var template_TO = this.templateInfo.To == null ? [] : this.templateInfo.To.split(',').map(x => { return { UserName: x, EmailAddress: x }; });
          var template_CC = this.templateInfo.CC == null ? [] : this.templateInfo.CC.split(',').map(x => { return { UserName: x, EmailAddress: x }; });
          var template_BCC = this.templateInfo.BCC == null ? [] : this.templateInfo.BCC.split(',').map(x => { return { UserName: x, EmailAddress: x }; });
          this.ComposeMail.controls["To"].setValue(template_TO);
          this.ComposeMail.controls["CC"].setValue(template_CC);
          this.ComposeMail.controls["BCC"].setValue(template_BCC);
          this.ComposeMail.controls["Subject"].setValue(this.templateInfo.Subject ?? "");
          var existing_Mailbody = this.originalEmailBody;
          var concated_Mailbody = this.templateInfo.MailBody + existing_Mailbody;
          this.ComposeMail.controls["MailBody"].setValue(concated_Mailbody);
        } else {
          this.templateInfo = new TemplateInfo();
          this.ComposeMail.controls["To"].setValue([]);
          this.ComposeMail.controls["CC"].setValue([]);
          this.ComposeMail.controls["BCC"].setValue([]);
          this.ComposeMail.controls["Subject"].setValue("");
          this.ComposeMail.controls["MailBody"].setValue("");
        }
      });
    }
    else if (this.msgType == "new") {
      this.templateInfo = new TemplateInfo();
      this.ComposeMail.controls["To"].setValue([]);
      this.ComposeMail.controls["CC"].setValue([]);
      this.ComposeMail.controls["BCC"].setValue([]);
      this.ComposeMail.controls["Subject"].setValue("");
      this.ComposeMail.controls["MailBody"].setValue("");
    }
  }

  getEmailTemplates() {
    this.subGetData3 = this.apiService.getData("api/Correspondence/GetEmailTemplates?EmailTempID=" + '' + "&ModuleID=" + this.ModuleID + "&ApplicationID=" + this.ApplicationID).subscribe(result => {
      if (result.Status && result.Data.length > 0) {
        this.emailTemplates = result.Data;
      } else {
        this.emailTemplates = [];
      }
    });
  }

  filterMail(event) {
    let filtered: any[] = [];
    let query = event.query;
    for (let i = 0; i < this.mails.length; i++) {
      let mail = this.mails[i];
      if (mail.EmailAddress.toLowerCase().indexOf(query.toLowerCase()) == 0) { filtered.push(mail); }
    }
    this.filteredMails = filtered;
  }

  addToSuggestionList(event, etype: 'To' | 'CC' | 'BCC') {
    let email = "";
    if (event.target.value.indexOf(',') > -1) {
      email = event.target.value.split(',')[0];
    }
    else if (event.target.value.indexOf(';') > -1) {
      email = event.target.value.split(';')[0];
    }
    else if (event.target.value != "" && event.target.value.indexOf(' ') > -1) {
      email = event.target.value.split(' ')[0];
    }
    let emails = this.ComposeMail.get(etype)?.value;
    if (email != null && email != "" && email != undefined) {
      if (emails == null || emails.length == 0)
        emails.push({ UserName: email, EmailAddress: email });
      else {
        let fEmail = emails.find(x => x.EmailAddress.toLowerCase() == email.toLowerCase());
        if (fEmail == null || fEmail == undefined)
          emails.push({ UserName: email, EmailAddress: email });
      }
      event.target.value = '';
    }
  }

  CheckValidateEmail(event, etype: 'To' | 'CC' | 'BCC') {
    if (event.target.value != "" && event.target.value.indexOf('@') > -1) {
      let email = event.target.value;
      let emails = this.ComposeMail.get(etype)?.value;
      if (emails == null || emails.length == 0)
        emails.push({ UserName: email, EmailAddress: email });
      else {
        let fEmail = emails.find(x => x.EmailAddress.toLowerCase() == email.toLowerCase());
        if (fEmail == null || fEmail == undefined)
          emails.push({ UserName: email, EmailAddress: email });
      }
      event.target.value = '';
    }
  }

  saveTempFiles(event: any) {

    var err: any = [];
    let msgF = "";
    var selectedFiles: File[] = event.target.files;
    const formData = new FormData();
    for (var i = 0; i < selectedFiles.length; i++) {
      let msg = this.validateFile(selectedFiles[i]);
      if (msg != "") {
        if (err.indexOf(msg) == -1) {
          msgF += msg;
          err.push(msg);
        }
      }
      else {
        formData.append(`files[${i}]`, selectedFiles[i]);
      }
    }
    this.subUploadMultiFiles = this.fileService.uploadMultiFiles(formData, "").subscribe(
      (result: any) => {

        result.Data.forEach(element => {
          this.uploadedFileArray.push({
            FileID: element.FileID,
            FileName: element.FileName,
            FileExt: element.FileExt,
            IsFromTemp: true,
            downloadUrl: serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + element.FileID
          })
        });
        if (result.FileName && result.FileExt)
          this.fileName = result.FileName;
      },
      err => {
        this.commonService.ValidationBanner(err);
      });
    if (msgF != "" && msgF.length > 0)
      this.commonService.ValidationBanner(msgF);
  }

  removeFile(fileObj) {
    this.uploadedFileArray.splice(this.uploadedFileArray.indexOf(fileObj), 1);
    if (this.msgType == "draft") {
      this.ComposeMail.controls["HasFileChange"].setValue(true);
    }
  }

  private validateFile(fileToUpload) {
    let isValidFile = true;
    let message = "";
    let fileType = fileToUpload?.name.substring(fileToUpload?.name.length - 4, fileToUpload.name.length);
    fileType = fileType?.toLowerCase();
    var filesize = fileToUpload.size;

    let fileExt = fileToUpload?.name.split('.').pop() as string;
    if (fileToUpload != null && (fileExt == 'exe')) {
      isValidFile = false;
      message += 'The system does not support .exe files. Please choose a different file format to save the details.';
    }
    else if (fileToUpload != null && (fileExt == 'crdownload')) {
      isValidFile = false;
      message += 'The system does not support .crdownload files. Please choose a different file format to save the details.';
    }
    else if (fileToUpload != null && ((filesize > 52428800))) {
      message += 'Accepts maximum file size 50MB';

    }
    if (fileToUpload != null && fileToUpload.name != null && fileToUpload.name.length > 250) {
      isValidFile = false;
      message += 'File name cannot be more than 250 characters <br/>';
    }
    return message;
  }

  getTeamMembersMails() {
    this.subGetData = this.apiService.getData("api/Correspondence/GetAutoCompleteMails?SubModule=" + this.SubModule).subscribe(result => {
      this.mails = result.Data;
    })
  }

}
